import { ItemModel } from "./item";

/**  @deprecated models should not ne used anymore */
export class SupplyModel extends ItemModel {}
